import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import CheckDiffText from './CheckDiffText';

class Sidebar extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { port, newPort } = this.props;

        return (
            <Fragment>
                <div className="col-lg-3 col-xs-3 sidebar">
                    <div className={"name"}>
                        <CheckDiffText
                            oldValue={port.name}
                            newValue={newPort.name}
                        />
                    </div>

                    <div className={"name country"}>
                        <CheckDiffText
                            oldValue={newPort.country ? newPort.country.name : newPort.country}
                            newValue={newPort.country ? newPort.country.name : newPort.country}
                        />
                    </div>

                    <div className="divider" />

                    <div className='info'>
                        <div className={"info__title"}>
                            <span className={'gray'}>UN LOCODE: </span>
                            <CheckDiffText
                                oldValue={port.unLoCode}
                                newValue={newPort.unLoCode}
                            />
                        </div>

                        <div className={"info__title"}>
                            <span className={'gray'}>Time Zone: </span>
                            <CheckDiffText
                                oldValue={port.timezone}
                                newValue={newPort.timezone}
                            />
                        </div>


                        <a href={ port.site } className="info__website">
                            <CheckDiffText
                                oldValue={port.site}
                                newValue={newPort.site}
                            />
                        </a>
                    </div>
                </div>
            </Fragment>
        );
    }
}

Sidebar.propTypes = {


};

Sidebar.defaultProps = {


};

export default connect(
    (state, { port, newPort }) => {
        return {
            port,
            newPort,
        };
    },
    dispatch => bindActionCreators({

    }, dispatch),
)(Sidebar);


// WEBPACK FOOTER //
// ./app/components/Regions/PortApprove/Sidebar.jsx